import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'src/context/AuthContext';
import Appbar from "src/components/appbar";

const ProtectedRoute = ({ element, allowedRoles }) => {
    const { isAuthenticated, role } = useAuth();

    if (!isAuthenticated) {
        // Not authenticated, redirect to login
        return <Navigate to="/" replace />;
    }

    if (allowedRoles && !allowedRoles.includes(role)) {
        // Authenticated but unauthorized role, redirect to own dashboard or default
        switch (role) {
            case 'admin':
                return <Navigate to="/admin/dashboard" replace />;
            case 'mcc':
                return <Navigate to="/mcc/mapping" replace />;
            case 'trainer':
                return <Navigate to="/trainer/dashboard" replace />;
            case 'trainee':
                return <Navigate to="/Trainee-details" replace />;
            case 'iti':
                return <Navigate to="/iti-home" replace />;
            case 'industry':
                return <Navigate to="/industry/dashboard" replace />;
            default:
                return <Navigate to="/" replace />;
        }
    }

    const hideAppbar = ['admin', 'mcc', 'industry', 'iti'].includes(role);

    return (
        <div className="w-full h-full overflow-x-hidden">
            {isAuthenticated && !hideAppbar && <Appbar />}
            {element}
        </div>
    );
};

export default ProtectedRoute;
